import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
import { AgentReleaseDto } from "healthex-common/agent.release.dtos";
import { plainToInstance } from "class-transformer";
export class AgentReleaseService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async createAgentRelease(input) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/agent/releases"), input, authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(AgentReleaseDto, response.data);
    }
    async getAgentReleases() {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/agent/releases"), authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(AgentReleaseDto, response.data);
    }
    async updateAgentRelease(id, input) {
        const response = await axios.put(generateURL(this.environment.API_BASE_URL, "/agent/releases/:id", { id }), input, authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(AgentReleaseDto, response.data);
    }
    async getAgentRelease(id) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/agent/releases/:id", { id }), authenticatedApiConfig(this.authenticationProvider));
        return response.data === "" ? null : plainToInstance(AgentReleaseDto, response.data);
    }
    async getMinimumAgentRelease() {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/agent/releases/minimum"), authenticatedApiConfig(this.authenticationProvider));
        return response.data === "" ? null : plainToInstance(AgentReleaseDto, response.data);
    }
    async getLatestAgentRelease() {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/agent/releases/latest"), authenticatedApiConfig(this.authenticationProvider));
        return response.data === "" ? null : plainToInstance(AgentReleaseDto, response.data);
    }
}
